import {FC, PropsWithChildren, useMemo} from 'react';
import { Parser } from 'expr-eval-fork';
import { useAllRoles } from '@hooks/userHooks';
import {useCurrentLanguageCode} from "@hooks/languageHooks";

interface LogicCondProps {
    condition?: any;
    roles?: string[];
    language?: string;
}

const Condition: FC<PropsWithChildren<LogicCondProps>> = ({ children, condition, roles, language }) => {

    const userRoles = useAllRoles();
    const currentLanguage = useCurrentLanguageCode();

    const result = useMemo(() => {
        if(condition === undefined) {
            return true;
        }
        if (typeof condition === 'string') {
            try {
                return Boolean(Parser.evaluate(condition));
            }
            catch (e) {
                return false;
            }
        }

        return !!condition;
    }, [condition]);

    const roleResult = !Array.isArray(roles)
        || roles.reduce((result, role) => result || userRoles.includes(role), false);
    const languageResult = !language || language === currentLanguage;

    if (result && roleResult && languageResult) {
        return <>{children}</>;
    }
    return null;
}

interface RolesCondProps {
    role?: string | string[];
}

const RolesCondition: FC<PropsWithChildren<RolesCondProps>> = ({ children, role }) => {
    const userRoles = useAllRoles();

    if (!role
        || (typeof role === 'string' && userRoles.includes(role))
        || (Array.isArray(role) && userRoles.findIndex(r => role.includes(r)) >= 0)) {
        return <>{children}</>
    }

    return null;
}

export {
    Condition,
    RolesCondition
}